import { gql } from '@apollo/client';

const orderFailed = gql`
  fragment orderFailed on OrderFailedPayload {
    type
    step
    errors {
      errorCode
      errorMessage
      errorDetails {
        key
        value
      }
    }
  }
`;

const orderSubmitted = gql`
  fragment orderSubmitted on OrderSubmittedPayload {
    type
    masterOrderId
  }
`;

export const ORDER_EBU_MUTATION = gql`
  mutation orderNative($input: OrderNativeInput!) {
    orderNative(input: $input) {
      id
      resource {
        cartId
        type
      }
    }
  }
`;

export const ORDER_EBU_SUBSCRIPTION = gql`
  subscription onCommandCreated(
    $cartId: ID!
    $jwt: String!
    $commandTypes: [CommandType!]!
  ) {
    onCommandCreated(cartId: $cartId, jwt: $jwt, commandTypes: $commandTypes) {
      id
      createdAt
      updatedAt
      resource {
        cartId
        type
        payload {
          ...orderFailed
          ...orderSubmitted
        }
      }
    }
  }
  ${orderFailed}
  ${orderSubmitted}
`;
